import { render, staticRenderFns } from "./BCSelCallStatusList.vue?vue&type=template&id=a17a466a&scoped=true"
import script from "./BCSelCallStatusList.vue?vue&type=script&lang=js"
export * from "./BCSelCallStatusList.vue?vue&type=script&lang=js"
import style0 from "./BCSelCallStatusList.vue?vue&type=style&index=0&id=a17a466a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17a466a",
  null
  
)

export default component.exports